import { Switch } from '@mui/material';
import { SettingsInputProps } from './SettingsInputProps';

export const BooleanSettingsInput = (props: SettingsInputProps) => {
  const checked = !!props.value?.intValue;

  return (
    <Switch
      size='small'
      checked={checked}
      onClick={() => props.onChange({ intValue: checked ? 0 : 1 })}
    />
  );
};
